import { Box, Button, FormikField as Field, H1, Input, Text, VStack } from '@betterment/samba-react';
import { WorkflowLayout } from '@betterment/shared-components';
import { Form, Formik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import Footer from '../../../../Shared/components-v2/footer/Footer';
import { retirementDetails, useRetirementStep } from '../FlowConfig';

type FormValues = Yup.InferType<typeof retirementDetails>;

export const RetirementDetailStep: React.FC = () => {
  const navigate = useNavigate();
  const { flowId } = useParams<{ flowId: string }>();
  const { commit, values } = useRetirementStep('retirementDetails');

  const initialValues: FormValues = {
    retirementZipCode: values!.retirementZipCode,
    retirementAge: values!.retirementAge,
  };

  const handleSubmit = (formValues: FormValues) => {
    commit(formValues);
    void navigate(`/add_purpose/retirement/${flowId}/desired_spending`);
  };

  return (
    <WorkflowLayout pageTitle="Retirement">
      <WorkflowLayout.Header workflowTitle={null} onClose={() => navigate('/')} onBack={() => navigate(-1)} />
      <WorkflowLayout.Content>
        <VStack css={{ gap: 'space.300' }}>
          <VStack css={{ gap: 'space.200' }}>
            <H1>Tell us about your retirement.</H1>
            <Text>We'll use this to build a plan tailored to where and how you want to live.</Text>
          </VStack>
          <Formik
            onSubmit={handleSubmit}
            initialValues={initialValues}
            validationSchema={retirementDetails}
            validateOnChange={false}
          >
            <Form>
              <Box css={{ display: 'grid', gap: 'space.200' }}>
                <Field name="retirementAge">
                  <Field.Label>When would you like to retire?</Field.Label>
                  <Field.Control>
                    <Input type="number" />
                  </Field.Control>
                  <Field.Description>
                    <Text variant="text50" color="text.weak">
                      Retiring later may increase Social Security benefits.
                    </Text>
                  </Field.Description>
                  <Field.ErrorMessage />
                </Field>
                <Field name="retirementZipCode">
                  <Field.Label>Where do you plan to live?</Field.Label>
                  <Field.Control>
                    <Input />
                  </Field.Control>
                  <Field.Description>
                    <Text variant="text50" color="text.weak">
                      Location affects taxes and cost of living, which impact how much you'll need.
                    </Text>
                  </Field.Description>
                  <Field.ErrorMessage />
                </Field>
                <Button type="submit" css={{ width: 'fit-content' }}>
                  Continue
                </Button>
              </Box>
            </Form>
          </Formik>
        </VStack>
      </WorkflowLayout.Content>
      <WorkflowLayout.Footer>
        <Footer />
      </WorkflowLayout.Footer>
    </WorkflowLayout>
  );
};
